import { render, staticRenderFns } from "./ContactProperties.vue?vue&type=template&id=f19f3918&scoped=true"
import script from "./ContactProperties.vue?vue&type=script&lang=js"
export * from "./ContactProperties.vue?vue&type=script&lang=js"
import style0 from "./ContactProperties.vue?vue&type=style&index=0&id=f19f3918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19f3918",
  null
  
)

export default component.exports